import type { Step } from '@/services/queries/operation_steps/types'

export const getTargetAssemblyGroupIds = ({
  activeStep,
  hidePreviousOperations,
  steps,
}: {
  activeStep: Step
  hidePreviousOperations: boolean
  steps: Step[]
}) => {
  if (hidePreviousOperations) return activeStep.assembly_group_ids

  return steps
    .filter(
      (step) =>
        step.parent === activeStep.parent &&
        step.order_number <= activeStep.order_number,
    )
    .flatMap((step) => step.assembly_group_ids)
}
